<script lang="ts">
  import { auth } from './lib/stores/auth';
  import AuthButton from './lib/components/AuthButton.svelte';
  import PaymentForm from './lib/components/PaymentForm.svelte';
  import PingPong from './lib/components/PingPong.svelte';
  import ResetPassword from './lib/components/ResetPassword.svelte';
  import MfaChallenge from './lib/components/MfaChallenge.svelte';
  import AccountSecurity from './lib/components/AccountSecurity.svelte';
</script>

<main>
  <h1>Welcome to Minertia</h1>
  <p>South African Payment Platform</p>
  <p>Powered by Cloudflare and Svelte</p>

  {#if $auth.recoveryMode}
    <ResetPassword />
  {:else if $auth.mfaRequired}
    <MfaChallenge />
  {:else}
    <AuthButton />
    {#if $auth.user}
      <AccountSecurity />
      <PingPong />
      <PaymentForm />
    {/if}
  {/if}
</main>

<style>
  main {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: 100vh;
    font-family: system-ui, -apple-system, sans-serif;
  }

  h1 {
    margin: 0;
    font-size: 3rem;
    color: #333;
  }

  p {
    margin: 0.5rem 0;
    color: #666;
    font-size: 1.2rem;
  }
</style>
